/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';
import { currencies, exchange } from '../../../utilities/constants';
import { MODAL_SCREENS } from '../constants';

const ReceivedItemLayout = ({ item, showScreen, onDetailsClick }) => {
  const { t: translate } = useTranslation();

  const handleOnClick = () => {
    showScreen(MODAL_SCREENS.RECEIVED_DETAILS);
    onDetailsClick(item);
  };

  const details = (
    <button
      type="button"
      className="btn yield-btn text-f6 py-2 px-3 border-0 text-f5 text-bolder"
      onClick={handleOnClick}>
      <b>{translate('details_button_title')}</b>
    </button>
  );

  return (
    <div
      className="row bg-lighter rounded-extra px-md-4 px-3 py-3 my-3 mx-0"
      role="button"
      onClick={handleOnClick}
      onKeyDown={null}
      tabIndex={-1}>
      <div className="col-md-3 col col-6 my-auto ps-0 text-f4 text-bolder">{`${formatNumber(
        item?.annualizedYield,
        exchange.FIAT_VALUE
      )}%`}</div>
      <div className="col-2 d-md-block d-none ps-0 my-auto text-f5 text-bolder">
        {item?.duration}
      </div>
      <div className="col-3 d-md-block d-none text-nowrap my-auto text-f5 text-bolder">{`${formatNumberWithComma(
        formatNumber(item?.settleCoinEffectivePurchasePrice, exchange.FIAT_VALUE)
      )} ${currencies.USDC.fullName}`}</div>
      <div className="col-2 d-md-block d-none me-auto my-auto">
        <div className="d-flex flex-row justify-content-between  align-items-center bg-black rounded-max ps-2 w-90">
          <p className="text-dark text-f6 text-bolder">{translate('received_label')}</p>
          <div className="w-25">
            <img
              src={`./assets/icons/${item?.expirationCurrency}.svg`}
              className="w-100"
              alt={item?.expirationCurrency}
            />
          </div>
        </div>
      </div>
      <div className="col-1 d-md-block d-none text-end my-auto pe-0">{details}</div>
      <div className="d-md-none d-block col-6 p-0">
        <div className="d-flex flex-column align-items-end ">
          <p>{`${formatNumberWithComma(formatNumber(item?.linkedPrice, exchange.FIAT_VALUE))} ${
            currencies.USDC.fullName
          }`}</p>
          <p className="text-shadow text-f5">
            {moment(item?.expirationDate, 'YYYYMMDDh:mm:ss').format('DD/MM/YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReceivedItemLayout;

ReceivedItemLayout.propTypes = {
  item: PropTypes.object.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
  showScreen: PropTypes.func.isRequired,
};
